<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<div class="row">
    <h1 mat-dialog-title>
        <strong>Visualización de liquidación por propietario</strong>
    </h1>
</div>
<mat-divider></mat-divider>
<br />
<div mat-dialog-content>

    <!-- Consolidado: aparece sólo cuando el propietario tiene más de un contrato.
         Con uno solo repetiría el detalle que está justo abajo. -->
    <div class="resumen-propietarios" *ngIf="resumenPropietarios.length > 0">
        <div class="resumen-titulo">
            <mat-icon>account_balance_wallet</mat-icon>
            <span>Total general por propietario</span>
        </div>

        <div class="resumen-fila" *ngFor="let resumen of resumenPropietarios;trackBy:trackByItems">
            <div class="resumen-persona">
                <span class="nombre">{{ resumen.propietario | titlecase }}</span>
                <span class="detalle">{{ resumen.cantidadContratos }} propiedades / contratos</span>
            </div>

            <div class="resumen-importes">
                <span class="importe">
                    <em>Cta. propietario</em>
                    {{ resumen.totalACuentaPropietario | currency }}
                </span>
                <span class="importe">
                    <em>Cálculo</em>
                    {{ resumen.totalCalculo | currency }}
                </span>
                <span class="importe">
                    <em>Comisiones</em>
                    {{ resumen.totalComisiones | currency }}
                </span>
                <span class="importe destacado" [class.negativo]="resumen.totalARendir < 0">
                    <em>Total a rendir</em>
                    {{ resumen.totalARendir | currency }}
                </span>
            </div>
        </div>
    </div>

    <div *ngIf="settlementByPropertyDto.length >= 1">
        <br>
        <div class="mat-accordeon-separate" *ngFor="let settlementsByProperty of settlementByPropertyDto">
            <mat-accordion *ngIf="settlementsByProperty.contratos.length > 0">
                <mat-expansion-panel *ngFor="let contratos of settlementsByProperty.contratos;let i=index;trackBy:trackByItems">

                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <span class="col0">
                <mat-checkbox *ngIf="contratoDetailDto != null" color="primary"
                  [checked]="contratoDetailDto.numeroContrato== contratos.contrato.numeroContrato" [disabled]="true"
                  (click)="$event.stopPropagation()">



                </mat-checkbox>
                <mat-checkbox *ngIf="contratoDetailDto == null" color="primary" [checked]="true" [disabled]="true"
                  (click)="$event.stopPropagation()">
                </mat-checkbox>
              </span>&nbsp;&nbsp;
                            <span class="col1 headLiquidacion"><strong>Propietario:</strong>
                {{
                isFalsy(contratos.propietario)
                ? ""
                : (contratos.propietario.persona.descripcion | titlecase)
                }}</span>&nbsp;&nbsp;
                            <span class="col2 headLiquidacion"><strong>Propiedad:</strong>
                {{
                isFalsy(contratos.propiedad)
                ? ""
                : isFalsy(contratos.propiedad.ubicacion)? "" : (contratos.propiedad.ubicacion | titlecase)
                }}
                -
                {{
                isFalsy(contratos.propiedad)
                ? ""
                : isFalsy(contratos.propiedad.piso) ? "" : (" "+contratos.propiedad.piso | uppercase)
                }}
                {{
                isFalsy(contratos.propiedad)
                ? ""
                : isFalsy(contratos.propiedad.departamento) ? "" : (" "+ contratos.propiedad.departamento
                | uppercase)
                }}</span>&nbsp;&nbsp;
                            <span class="col3 headLiquidacion"><strong>Contrato:</strong>
                {{
                isFalsy(contratos.contrato)
                ? ""
                : contratos.contrato.numeroContrato
                }}</span>&nbsp;&nbsp;
                            <span class="col4 headLiquidacion"><strong>Importe a liquidar:</strong>
                {{ isFalsy(getImporteLiquidacion(contratos)) ? 0 : getImporteLiquidacion(contratos) | currency }}</span>

                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <!-- Dos formas de ver lo mismo. La de comprobante va primero
                         porque es la que se compara contra el PDF; la de detalle
                         queda como estaba, para revisar concepto por concepto. -->
                    <mat-tab-group animationDuration="0ms">

                      <mat-tab>
                        <ng-template mat-tab-label>
                          <mat-icon class="icono-tab">receipt_long</mat-icon>
                          Comprobante
                        </ng-template>

                        <ng-container *ngTemplateOutlet="vistaComprobante; context: { contratos: contratos }">
                        </ng-container>
                      </mat-tab>

                      <mat-tab>
                        <ng-template mat-tab-label>
                          <mat-icon class="icono-tab">list_alt</mat-icon>
                          Detalle
                        </ng-template>

                    <div *ngFor="let settlement of contratos.settlements;let i=index;trackBy:trackByItems" class="container">
                        <h2>
                            <p>Detalle liquidación</p>
                        </h2>
                        <strong>
              <h3>Servicios Propiedad</h3>
            </strong>
                        <table mat-table [dataSource]="settlement.detallesServiciosPropiedad" *ngIf="settlement.detallesServiciosPropiedad.length != 0" class="mat-elevation-z8">
                            <ng-container matColumnDef="periodo">
                                <th mat-header-cell *matHeaderCellDef>Periodo</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.periodoMes }}/{{ element.periodoAnio }}
                                </td>
                                <td mat-footer-cell *matFooterCellDef>Total</td>
                            </ng-container>
                            <ng-container matColumnDef="servicio">
                                <th mat-header-cell *matHeaderCellDef>Servicio</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ isFalsy(element.servicioPropiedad) ? "" : isFalsy(element.servicioPropiedad.servicio) ? "" : (element.servicioPropiedad.servicio.descripcion | titlecase) }}
                                </td>
                                <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                            <ng-container matColumnDef="importe">
                                <th mat-header-cell *matHeaderCellDef>Importe</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.importeATenerEnCuenta | currency }}
                                </td>
                                <td mat-footer-cell *matFooterCellDef>
                                    {{ getTotalServicioPropiedad( settlement.detallesServiciosPropiedad ) | currency }}
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsDetallesServicios"></tr>
                            <tr mat-row *matRowDef="
                  let row;
                  columns: displayedColumnsDetallesServicios
                "></tr>
                            <tr mat-footer-row *matFooterRowDef="
                  displayedColumnsDetallesServicios;
                  sticky: true
                "></tr>
                        </table>

                        <app-sin-datos *ngIf="settlement.detallesServiciosPropiedad.length == 0"></app-sin-datos>

                        <strong>
              <h3>Periodos</h3>
            </strong>
                        <table mat-table [dataSource]="settlement.periodosContrato" *ngIf="settlement.periodosContrato.length != 0" class="mat-elevation-z8">
                            <ng-container matColumnDef="periodo">
                                <th mat-header-cell *matHeaderCellDef>Periodo</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.periodoMes }}/{{ element.periodoAnio }}
                                </td>
                                <td mat-footer-cell *matFooterCellDef><strong>Total</strong></td>
                            </ng-container>
                            <ng-container matColumnDef="importeAlquiler">
                                <th mat-header-cell *matHeaderCellDef>Importe Alquiler</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.importeAlquiler | currency }}
                                </td>
                                <td mat-footer-cell *matFooterCellDef>
                                    {{ getTotalPeriodosContrato(settlement.periodosContrato) | currency }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="importeComision">
                                <th mat-header-cell *matHeaderCellDef>Importe Comisión</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.comisionInmobiliara | currency }} ( {{ isFalsy(contratos.contrato) ? "" : contratos.contrato.porcentajeComisionPropietario }}%)
                                </td>
                                <td mat-footer-cell *matFooterCellDef>
                                    {{ getTotalImporteComisionPeriodo(settlement.periodosContrato) | currency }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="importePunitorio">
                                <th mat-header-cell *matHeaderCellDef>Importe Punitorio</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.importePunitorio | currency }}
                                </td>
                                <td mat-footer-cell *matFooterCellDef>
                                    {{ getTotalImporPunitorio(settlement.periodosContrato) | currency }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="importeTotal">
                                <th mat-header-cell *matHeaderCellDef>Importe Total</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.importeAlquiler + element.importePunitorio - element.comisionInmobiliara | currency }}
                                </td>
                                <td mat-footer-cell *matFooterCellDef>
                                    {{ getTotalImporte(settlement.periodosContrato) | currency }}
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsPeriodos"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsPeriodos"></tr>
                            <tr mat-footer-row *matFooterRowDef="displayedColumnsPeriodos; sticky: true"></tr>
                        </table>
                        <app-sin-datos *ngIf="settlement.periodosContrato.length == 0"></app-sin-datos>

                        <strong>
              <h3>Movimientos</h3>
            </strong>
                        <table mat-table [dataSource]="settlement.movimientos" *ngIf="settlement.movimientos.length != 0" class="mat-elevation-z8">
                            <ng-container matColumnDef="mov_periodo">
                                <th mat-header-cell *matHeaderCellDef>Periodo</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.periodoMes }}/{{ element.periodoAnio }}
                                </td>
                                <td mat-footer-cell *matFooterCellDef>Total</td>
                            </ng-container>
                            <ng-container matColumnDef="mov_tipoMovimiento">
                                <th mat-header-cell *matHeaderCellDef>Tipo Movimiento</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ isFalsy(element.tipoMovimiento) ? "" : (element.tipoMovimiento.descripcion | titlecase) }}
                                </td>
                                <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                            <ng-container matColumnDef="mov_descripcion">
                                <th mat-header-cell *matHeaderCellDef>Descripción</th>
                                <td mat-cell *matCellDef="let element">
                                    {{isFalsy(element.descripcion) ? "" : element.descripcion }}
                                </td>
                                <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                            <ng-container matColumnDef="mov_importe">
                                <th mat-header-cell *matHeaderCellDef>Importe</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.importe | currency }}
                                </td>
                                <td mat-footer-cell *matFooterCellDef>
                                    {{ getTotalMovimientos(settlement.movimientos) | currency }}
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsMovimientos"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsMovimientos"></tr>
                            <tr mat-footer-row *matFooterRowDef="displayedColumnsMovimientos; sticky: true"></tr>
                        </table>
                        <app-sin-datos *ngIf="settlement.movimientos.length == 0"></app-sin-datos>
                    </div>
                      </mat-tab>
                    </mat-tab-group>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
    <!-- ============ VISTA CON FORMATO DE COMPROBANTE ============
         Los números salen de contratos.simulacion, que arma el back con el mismo
         código que usa al liquidar. Acá NO se suma nada: si esta pantalla
         recalculara por su cuenta, volvería a divergir del PDF. -->
    <ng-template #vistaComprobante let-contratos="contratos">
      <div class="comprobante" *ngIf="tieneSimulacion(contratos); else sinSimulacion">

        <div class="comprobante-cabecera">
          <div class="dato">
            <span class="etiqueta">Propiedad</span>
            <span class="valor">{{ getUbicacionPropiedad(contratos) | titlecase }}</span>
          </div>
          <div class="dato">
            <span class="etiqueta">Inquilino</span>
            <span class="valor">{{ contratos.contrato?.inquilino?.persona?.descripcion }}</span>
          </div>
          <div class="dato">
            <span class="etiqueta">Contrato</span>
            <span class="valor">{{ contratos.contrato?.numeroContrato }}</span>
          </div>
          <div class="dato">
            <span class="etiqueta">Vto. contrato</span>
            <span class="valor">{{ contratos.contrato?.fechaVencimiento | date:'dd/MM/yyyy' }}</span>
          </div>
        </div>

        <table class="tabla-comprobante">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Concepto</th>
              <th>Descripción</th>
              <th>Periodo</th>
              <th class="text-right">Debe</th>
              <th class="text-right">Haber</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let linea of contratos.simulacion.settlementReceiptDetail; trackBy: trackByItems">
              <td>{{ linea.fecha | date:'dd/MM/yyyy' }}</td>
              <!-- El asterisco marca lo que se imputa a cuenta del propietario -->
              <td>{{ linea.concepto }}{{ linea.esCuentaPropietario ? ' *' : '' }}</td>
              <td class="detalle">{{ linea.detalle }}</td>
              <td>{{ linea.periodo }}</td>
              <td class="text-right">{{ linea.debe | currency }}</td>
              <td class="text-right">{{ linea.haber | currency }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="4"><b>Total</b></td>
              <td class="text-right"><b>{{ contratos.simulacion.totalDebe | currency }}</b></td>
              <td class="text-right"><b>{{ contratos.simulacion.totalHaber | currency }}</b></td>
            </tr>
          </tfoot>
        </table>

        <div class="comprobante-totales">
          <div class="linea-total">
            <span>TOTAL CTA PROPIETARIO <small>(*)</small>:</span>
            <span>{{ contratos.simulacion.totalACuentaPropietario | currency }}</span>
          </div>
          <div class="linea-total">
            <span>TOTAL DE CALCULO:</span>
            <span>{{ contratos.simulacion.totalCalculo | currency }}</span>
          </div>
          <div class="linea-total">
            <span>TOTAL DE COMISIONES:</span>
            <span>{{ contratos.simulacion.totalComisiones | currency }}</span>
          </div>
          <div class="linea-total destacado">
            <span>TOTAL A RENDIR:</span>
            <span>{{ contratos.simulacion.totalARendir | currency }}</span>
          </div>
        </div>

        <p class="nota-asterisco">
          (*) Conceptos que se imputan a la cuenta del propietario y no forman parte
          de la base de cálculo de comisiones.
        </p>

        <p class="aviso-previa">
          <mat-icon>info_outline</mat-icon>
          Previsualización: todavía no se generó el comprobante. Los importes son los
          que va a imprimir el PDF.
        </p>
      </div>

      <ng-template #sinSimulacion>
        <app-sin-datos
          icono="receipt_long"
          mensaje="No se pudo armar la vista de comprobante"
          detalle="Revisá el detalle en la otra pestaña."
          [compacto]="true">
        </app-sin-datos>
      </ng-template>
    </ng-template>

    <div *ngIf="settlementByPropertyDto.length == 0">
        <app-sin-datos></app-sin-datos>
    </div>
</div>
<div mat-dialog-actions>
    <div *ngIf="contratoDetailDto != null">
        <button mat-raised-button *appRole="['Contratos.GeneraLiquidacion']" [disabled]="esLiquidacionGenerada" (click)="agregarLiquidacion()" color="primary">
      Generar Liquidacion
    </button>
    </div>

</div>